module.exports = __webpack_public_path__ + "img/kit-box-sold.a7d5def.png";